import { ChangeDetectorRef, ElementRef } from '@angular/core';

export class FileMissingTooltipHelper {
  open: Record<string, boolean> = {};
  private timers: Record<string, ReturnType<typeof setTimeout> | undefined> = {};

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly el: ElementRef
  ) {}

  show(fieldKey: string): void {
    clearTimeout(this.timers[fieldKey]);
    this.open[fieldKey] = true;
  }

  hide(fieldKey: string, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    clearTimeout(this.timers[fieldKey]);
    this.timers[fieldKey] = setTimeout(() => {
      this.open[fieldKey] = false;
      this.cdr.detectChanges();
    }, 150);
  }

  toggle(fieldKey: string, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.open[fieldKey]) {
      clearTimeout(this.timers[fieldKey]);
      this.open[fieldKey] = false;
    } else {
      this.show(fieldKey);
    }
  }

  onKeydown(fieldKey: string, event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      event.stopPropagation();
      clearTimeout(this.timers[fieldKey]);
      this.open[fieldKey] = false;
      const trigger = this.el.nativeElement.querySelector(
        `[aria-controls="file-missing-tooltip-${fieldKey}"]`
      );
      trigger?.focus();
    }
  }

  clearTimers(): void {
    Object.values(this.timers).forEach(timer => clearTimeout(timer));
    this.timers = {};
  }
}
